import { ICartProduct } from '../../generalTypes'
import { IProduct } from '../CategoriesReducer/types'

export const initialState: IBucket = {
  products: [],
}

export interface IBucket {
  products: IBucketProduct[]
}

export interface IMenuItemsBucket {
  count: number
  kitchenInfo: any[]
  name: string
  price: string
  productId: number
  menuIndex: number
  // the server's step id (position in the Sets string) — stable across a
  // register-scoped rebuild, unlike menuIndex which is the client's array index
  menuId?: number
  imageUrl?: string
  categoryId_origin?: number
  categoryId?: number
  isFixed?: boolean
}

export type ProductTemplateIdType =
  | number
  | 'discount'
  | 'individualPrice'
  | 'offerPrice'

export interface IBucketProduct extends ICartProduct {
  menuItems?: IMenuItemsBucket[]
  kitchenInfo: string
  addedAsWeight: boolean
  uniqueId: string
  productTemplateId: ProductTemplateIdType
  // Set by applyOfferPricesToBucket: price was replaced with the live Angebotspreis,
  // so no % discount may be applied on top of it (Smart_Checkout never stacks them).
  offerApplied?: boolean
}

export interface IProductWithBucketProduct
  extends Omit<IProduct, 'kitchenInfo'>,
    IBucketProduct {
  kitchenInfo: string
  uniqueId: string
  menuItems: any[]
  // not sure if productTemplateId is needed here
  productTemplateId: number
}
